import { shouldDelegateEvent, sendNativeEvent, } from '#pplx/frontend/apps/ask/native-bridges/nativeBridge.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { useCallback } from 'react';
export function useExecuteClientsideTool() {
    return useCallback((toolCalls, taskId, entryUuid) => {
        for (const toolCall of toolCalls) {
            if (toolCall.call_external_tool) {
                if (!shouldDelegateEvent()) {
                    logger.warn('clientsideTool: native bridge not available, skipping call_external_tool');
                    continue;
                }
                logger.info('clientsideTool: call_external_tool');
                sendNativeEvent({
                    type: 'pplx.clientside.call_external_tool',
                    data: {
                        ...toolCall.call_external_tool,
                        backend_uuid: taskId,
                        task_id: taskId,
                        entry_uuid: entryUuid,
                    },
                });
            }
            else if (toolCall.list_external_tools) {
                if (!shouldDelegateEvent()) {
                    logger.warn('clientsideTool: native bridge not available, skipping list_external_tools');
                    continue;
                }
                logger.info('clientsideTool: list_external_tools');
                sendNativeEvent({
                    type: 'pplx.clientside.list_external_tools',
                    data: {
                        ...toolCall.list_external_tools,
                        backend_uuid: taskId,
                        task_id: taskId,
                        entry_uuid: entryUuid,
                    },
                });
            }
            else if (toolCall.describe_external_tools) {
                if (!shouldDelegateEvent()) {
                    logger.warn('clientsideTool: native bridge not available, skipping describe_external_tools');
                    continue;
                }
                logger.info('clientsideTool: describe_external_tools');
                sendNativeEvent({
                    type: 'pplx.clientside.describe_external_tools',
                    data: {
                        ...toolCall.describe_external_tools,
                        backend_uuid: taskId,
                        task_id: taskId,
                        entry_uuid: entryUuid,
                    },
                });
            }
        }
    }, []);
}
//# sourceMappingURL=useExecuteClientsideTool.js.map